import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';
import { CaseData, CompositeKeys, CasePermissions } from 'app/types-shared';
import { RiskMatrixDefinition, ViewMode } from 'app/area/case/types-store';

export const ACTION = {
  REQUEST_CASE: 'CASE:REQUEST_CASE',
  RECEIVE_CASE: 'CASE:RECEIVE_CASE',
  RECEIVE_CASE_PERMISSIONS: 'CASE:RECEIVE_CASE_PERMISSIONS',
  FAIL_CASE_DATA: 'CASE:FAIL_CASE_DATA',
  REQUEST_CASE_RISK_MATRIX_DEFINITION: 'CASE:REQUEST_CASE_RISK_MATRIX_DEFINITION',
  RECEIVE_CASE_RISK_MATRIX_DEFINITION: 'CASE:RECEIVE_CASE_RISK_MATRIX_DEFINITION',
  SELECT_DOCUMENT_ITEM: 'CASE:SELECT_ITEM',
  CHANGE_VIEW_MODE: 'CASE:CHANGE_VIEW_MODE'
};

export class ChildItemSelection {
  public type: string = ACTION.SELECT_DOCUMENT_ITEM;
  public key: CompositeKeys;
  constructor(key: CompositeKeys){
    this.key = key;
  }
}

export class RequestCase {
  public type: string = ACTION.REQUEST_CASE;
  public caseNumber: number;
  constructor(caseNumber: number) {
    this.caseNumber = caseNumber;
  }
}

export class ReceiveCase {
  public type: string = ACTION.RECEIVE_CASE;
  public caseNumber: number;
  public data: CaseData;
  public uiDefinition: UiDefinition;

  constructor(caseNumber: number, data: CaseData, uiDefinition: UiDefinition) {
    this.caseNumber = caseNumber;
    this.data = data;
    this.uiDefinition = uiDefinition;
  }
}

export class LoadCaseFailure{
  public type: string = ACTION.FAIL_CASE_DATA;
}

export class ReceiveCasePermissions {
  public type: string = ACTION.RECEIVE_CASE_PERMISSIONS;
  public caseNumber: number;
  public data: CasePermissions;

  constructor(caseNumber: number, data: CasePermissions) {
    this.caseNumber = caseNumber;
    this.data = data;
  }
}

export class RequestCaseRiskMatrixDefinition {
  public type: string = ACTION.REQUEST_CASE_RISK_MATRIX_DEFINITION;
  public caseTypeId: number;

  constructor(caseTypeId: number) {
    this.caseTypeId = caseTypeId;
  }
}

export class ChangeViewMode {
  public type: string = ACTION.CHANGE_VIEW_MODE;
  public mode: ViewMode;

  constructor(mode: ViewMode) {
    this.mode = mode;
  }
}

export class ReceiveCaseRiskMatrixDefinition {
  public type: string = ACTION.RECEIVE_CASE_RISK_MATRIX_DEFINITION;
  public caseTypeId: number;
  public riskMatrixDefinition: RiskMatrixDefinition;

  constructor(caseTypeId: number, riskMatrixDefinition: RiskMatrixDefinition) {
    this.caseTypeId = caseTypeId;
    this.riskMatrixDefinition = riskMatrixDefinition;
  }
}
